import { Position, Toaster } from '@blueprintjs/core'

export const AppToaster = Toaster.create({
  className: 'toaster-yoda',
  position: Position.BOTTOM_RIGHT,
})
